<template>
  <div class="costume-nav-bar flex column gap10">
    <router-link 
      v-for="filterItem in allRouteFilters" :key="filterItem.id"
      :to="{ name: 'CostumePage', query: { page: filterItem.name  }, ...(baseRoute || {}) }"
      class="nav-item"
      :class="{ selected: $route.query.page === filterItem.name }"
    >
      <p class="hover-pop nav-item-msg flex align-center gap10">
        <span
          v-html="iconForRouteName(filterItem.name)"
          class="svg-parrent"
        ></span>
        {{filterItem.name}}
      </p>
    </router-link>
  </div>
</template>

<script>
import { organizationService } from '../../organization/organization.service';
import { getSvgs } from '@/apps/megaphonApp/assets/images/svgs';
export default {
  name: 'CostumeNavBar',
  props: {
    filterRoutes: Function,
    baseRoute: Object,
    routeRoles: Array,
    // beforeSvg is no longer used for the icon; kept for backwards compat
    beforeSvg: String
  },
  computed: {
   org () {
      return this.$store.getters['organization/selectedItem'] || {};
    },
    allRouteFilters() {
      const routes = organizationService.getOrgRoutesByRoles(this.org, this.routeRoles || ['client']).filter(c => !c.hideFromUi);
      if (!this.filterRoutes) return routes;
      return routes.filter(this.filterRoutes);
    },
    iconSvgs() {
      const svgs = getSvgs().navActions || {};
      return {
        // Main program views (Figma-aligned) – support both spellings
        'כל התכניות': svgs.tv || '',
        'תוכניות בעריכה': svgs.programsEditing || svgs.tv || '',
        'תכניות בעריכה': svgs.programsEditing || svgs.tv || '',
        'תוכניות שהופצו': svgs.programsSent || svgs.tv || '',
        'תכניות שהופצו': svgs.programsSent || svgs.tv || '',
        // Calendar / schedule views
        'לוח חודשי': svgs.stats || svgs.tv || '',
        'לוח שבועי': svgs.stats || svgs.tv || '',
        // Contacts & system
        'אנשי קשר להפצה': svgs.contacts || svgs.users || svgs.tv || '',
        'מערכת': svgs.settings || svgs.management || svgs.tv || '',
      };
    },
    iconForRouteName() {
      const defaultIconSvg = getSvgs().navActions?.tv || ''
      return (routeName) => {
        const key = (routeName || '').trim()
        return this.iconSvgs[key] || defaultIconSvg
      }
    },
  },
}
</script>

<style lang="scss">
@import '@/assets/styles/global/index';
.costume-nav-bar {
  width: 100%;
  .nav-item {
    display: flex;
    align-items: center;
    width: 100%;
    padding: em(12px) em(16px);
    text-decoration: none;
    font-weight: 400;
    font-size: rem(16px);
    line-height: 1.5;

    &.selected {
      font-weight: 600;
    }

    .nav-item-msg {
      display: flex;
      align-items: center;
      gap: em(10px);
    }

    .svg-parrent {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      width: rem(24px);
      height: rem(24px);
      flex-shrink: 0;
    }
  }
}
</style>